import { Spin } from "antd"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { DataBox } from "@/global/interface/device/data-box"
import { DeviceCollectionHistory } from "@/global/interface/device/sensor"
import { addDataBoxCollectionHistory, getDataBoxCollectionByDataBoxId, updateDataBox } from "@/api/device/data-box"
import { getDateDetailName } from "@/global/utils/date-utils"
interface Iprops {
    data: DataBox,
    setData: (e) => void
}
export default function DataBoxCollectionPanel(props: Iprops) {

    const { data } = props

    const { projectId } = useParams()

    const [collectionList, setCollectionList] = useState<DeviceCollectionHistory[]>([])

    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        if (!data) return
        generateData()
    }, [data])

    const generateData = () => {
        getDataBoxCollectionByDataBoxId(data.id).then(res => {
            let resList: DeviceCollectionHistory[] = res?.data || []
            setCollectionList(resList)
        })
    }

    // 修改设备运行状态
    const onDeviceRunStatusChange = () => {
        if (!data) return
        setLoading(true)
        if (data?.start) {
            updateDataBox(data.id, { start: false }).then(res => {
                data.start = false
                props.setData({ ...data })
                return addDataBoxCollectionHistory(Number(projectId), data.id, { personName: "用户", start: false })
            }).finally(() => {
                setLoading(false)
                generateData()
            })
        } else {
            updateDataBox(data.id, { start: true }).then(res => {
                data.start = true
                props.setData({ ...data })
                return addDataBoxCollectionHistory(Number(projectId), data.id, { personName: "用户", start: true })
            }).finally(() => {
                setLoading(false)
                generateData()
            })
        }
    }

    return (
        <div className="collection-main">
            <div className="title">
                采集
            </div>
            <div className="collection-list">
                {collectionList?.map((item, index) => (
                    <div className="list-item" key={index}>
                        <div className="label">
                            {"采集记录" + (index + 1)}
                        </div>
                        <div className="value">
                            {getDateDetailName(item.startTime) + " " + (item?.personName || "用户") + "对" + data?.name + "进行了 " + (item?.start ? "启动" : "停止") + " 采集"}
                        </div>
                    </div>
                ))}

            </div>
            <div className="btn-area">
                {loading ? (
                    <Spin />
                ) : (
                    <>
                        {data?.start ? (
                            <div className="stop-btn" onClick={() => { onDeviceRunStatusChange() }}>
                                停止采集
                            </div>
                        ) : (
                            <div className="check-btn" onClick={() => { onDeviceRunStatusChange() }}>
                                启动采集
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}